import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { FrameHeader } from '../components/atomic/dialog/frame_header/FrameHeader';
import { SolidFrameBackground } from '../components/atomic/dialog/solid_frame_background/SolidFrameBackground';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { Button } from './button/Button';
import { ClaudiCharacter } from './content/ClaudiCharacter';
import { ClaudiSticker } from './content/ClaudiSticker';
import { OpenedStickerBackground } from './content/OpenedStickerBackground';
import { RewardPopup } from './content/RewardPopup';
import { Decor } from './decor/Decor';
import { StickerShine } from './decor/StickerShine';
import type { StickerRewardScreenController } from './StickerRewardScreenController';
import type { StickerRewardScreenModel } from './StickerRewardScreenModelScreen';
import { HeaderText } from './texts/HeaderText';
import './sticker_reward_screen.css';

export type StickerRewardScreenViewProps = ScreenViewProps<
  StickerRewardScreenModel,
  StickerRewardScreenController
>;

/** Sticker reward screen after a successful delivery. */
export function StickerRewardScreenView({
  model,
  controller,
}: StickerRewardScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen sticker-reward-screen">
      <SkyAtmosphere variant="delivery" />
      <div
        className="sticker-reward-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <SolidFrameBackground />
        <FrameHeader showSubHeader={false} />
        <HeaderText />
        <OpenedStickerBackground />
        <StickerShine />
        <Decor />
        <RewardPopup text={model.sticker.hint} />
        <ClaudiSticker src={model.stickerIconSrc} alt={model.sticker.hint} />
        <ClaudiCharacter />
        <Button onClick={controller.handleClaim} />
      </div>
    </div>
  );
}
